/* eslint-disable @next/next/no-img-element */
import { apiPath } from '@/redux/apiPath';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { MapOverlay } from '@/types/models';
import { useEffect, useState } from 'react';

interface Props {
  overlay: Pick<MapOverlay, 'name' | 'id'>;
}

export const OverlaySingleLegend = ({ overlay }: Props): JSX.Element => {
  const overlayName = overlay.name;
  const overlayId = overlay.id;
  const [legendUrl, setLegendUrl] = useState<string | null>(null);

  useEffect(() => {
    let isCurrent = true;
    let objectUrl: string | null = null;

    // the legend comes from an authenticated endpoint exposed as a POST, so it cannot be loaded by
    // assigning the url to `img.src` - the bytes have to be fetched and turned into an object url
    axiosInstanceNewAPI
      .post<Blob>(apiPath.downloadOverlayLegend(overlayId), undefined, { responseType: 'blob' })
      .then(({ data }) => {
        if (!isCurrent) {
          return;
        }
        objectUrl = URL.createObjectURL(data);
        setLegendUrl(objectUrl);
      })
      .catch(() => {
        if (isCurrent) {
          setLegendUrl(null);
        }
      });

    return (): void => {
      isCurrent = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [overlayId]);

  return (
    <div>
      <p className="mb-5 text-sm font-semibold">{overlayName}</p>
      {legendUrl && <img src={legendUrl} alt={`${overlayName} legend`} />}
    </div>
  );
};
